import { PayrollFrequency } from '../../models/payroll-info';
import { Selector } from '@ngxs/store';
import { IPersonEditorState, PersonEditorState } from './PersonEditor.state';

export class SetJobDetailsFormState {
  static readonly type = '[JobDetailsForm] Set Job Details Form State';
  constructor(public payload: string) {}
}

export class SetEmployeeId {
  static readonly type = '[JobDetailsForm] Set Employee Id';
  constructor(public payload: number) {}
}

export class SetHireDate {
  static readonly type = '[JobDetailsForm] Set Hire Date';
  constructor(public payload: { year: number; month: number; day: number }) {}
}

export class SetShouldReportAsNewHire {
  static readonly type = '[JobDetailsForm] Set Should Report As New Hire';
  constructor(public payload: string) {}
}

export class SetWorksIn {
  static readonly type = '[JobDetailsForm] Set Works In';
  constructor(public payload: string) {}
}

export class SetOKToAutoPay {
  static readonly type = '[JobDetailsForm] Set OK To Auto Pay';
  constructor(public payload: string) {}
}

export class SetPayFrequency {
  static readonly type = '[JobDetailsForm] Set Pay Frequency';
  constructor(public payload: PayrollFrequency) {}
}

export class SetLocation {
  static readonly type = '[JobDetailsForm] Set Location';
  constructor(public payload: string) {}
}

export class SetDivision {
  static readonly type = '[JobDetailsForm] Set Division';
  constructor(public payload: string) {}
}

export class SetDepartment {
  static readonly type = '[JobDetailsForm] Set Department';
  constructor(public payload: string) {}
}

export class SetJobTitle {
  static readonly type = '[JobDetailsForm] Set Job Title';
  constructor(public payload: string) {}
}

export class SetIsSeasonal {
  static readonly type = '[JobDetailsForm] Set Is Seasonal';
  constructor(public payload: boolean) {}
}

export class SetFullTimePartTime {
  static readonly type = '[JobDetailsForm] Set Full Time Part Time';
  constructor(public payload: string) {}
}

export class SetIsOwnerOfficer {
  static readonly type = '[JobDetailsForm] Set Is Owner Officer';
  constructor(public payload: boolean) {}
}
export class SetSOCCode {
  static readonly type = '[JobDetailsForm] Set SOC Code';
  constructor(public payload: string) {}
}

export class SetOccupationId {
  static readonly type = '[JobDetailsForm] Set Occupation Id';
  constructor(public payload: any) {}
}

export class SetBasisOfPayment {
  static readonly type = '[JobDetailsForm] Set Basis Of Payment';
  constructor(public payload: any) {}
}

export class SetWorkEmail {
  static readonly type = '[JobDetailsForm] Set Work Email';
  constructor(public payload: string) {}
}

export class SetWorkPhoneNumber {
  static readonly type = '[JobDetailsForm] Set Work Phone Number';
  constructor(public payload: string) {}
}

export class SetOriginalHireDate {
  static readonly type = '[JobDetailsForm] Set Original Hire Date';
  constructor(public payload: { year: number; month: number; day: number }) {}
}

export class SetIncludeNonW2InWorkersComp {
  static readonly type = '[JobDetailsForm] Set Include Non W2 In Workers Comp';
  constructor(public payload: boolean) {}
}

export class SetWorkersCompCode {
  static readonly type = '[JobDetailsForm] Set Workers Comp Code';
  constructor(public payload: string) {}
}

export class SetWorkersCompOwnerStatus {
  static readonly type = '[JobDetailsForm] Set Workers Comp Owner Status';
  constructor(public payload: string) {}
}

export class SetWorkersCompLimitId {
  static readonly type = '[JobDetailsForm] Set Workers Comp Limit Id';
  constructor(public payload: string) {}
}

export class SetLaborAllocationTotal {
  static readonly type = '[JobDetailsForm] Set Labor Allocation Total';
  constructor(public payload: number) {}
}
